import { Modal } from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import { arrayOf, bool, func, shape, string } from "prop-types";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

import ChooseStyleTemplates from "./components/ChooseStyleTemplate";
import DocumentSource from "./components/DocumentSource";
import ResolveOutlineConflicts from "./components/ResolveOutlineConflicts";
import StartWritingProposalOutlineContext from "./context";

export const STEPS_KEYS = {
  SOURCE: "SOURCE",
  TEMPLATES: "TEMPLATES",
  CONFLICTS: "CONFLICTS",
};

const WIZARD_ROUTES = {
  [STEPS_KEYS.CONFLICTS]: ResolveOutlineConflicts,
  [STEPS_KEYS.TEMPLATES]: ChooseStyleTemplates,
  [STEPS_KEYS.SOURCE]: DocumentSource,
};

const StartWritingProposalOutlineWizard = ({
  childSections = [],
  hasConflicts,
  onConfirmStart,
  onResolveConflicts,
}) => {
  const [step, setStep] = useState(STEPS_KEYS.SOURCE);
  const [source, setSource] = useState(undefined);
  const [templateId, setTemplateId] = useState(undefined);
  const CurrentRoute = WIZARD_ROUTES[step] || DocumentSource;

  const dispatch = useDispatch();
  const providerValue = {
    childSections,
    hasConflicts,
    onConfirmStart,
    onResolveConflicts,
    setSource,
    setStep,
    setTemplateId,
    source,
    step,
    templateId,
  };

  const onClickCancel = (e) => {
    e?.preventDefault();
    dispatch(hideModal(modalTypes.START_WRITING_PROPOSAL_OUTLINE_WIZARD));
  };

  return (
    <Modal
      data-testid="start-writing-proposal-outline-wizard"
      className="fade-in"
      show
      onDismiss={onClickCancel}
      backdrop
      centered
    >
      <Modal.Header>Create New Document</Modal.Header>

      <StartWritingProposalOutlineContext.Provider value={providerValue}>
        <CurrentRoute />
      </StartWritingProposalOutlineContext.Provider>
    </Modal>
  );
};

StartWritingProposalOutlineWizard.propTypes = {
  childSections: arrayOf(
    shape({
      title: string,
    })
  ),
  hasConflicts: bool,
  onConfirmStart: func,
  onResolveConflicts: func,
};

export default StartWritingProposalOutlineWizard;
